import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { 
  Type, 
  Hash, 
  Calendar, 
  Clock, 
  CheckSquare, 
  Circle, 
  List, 
  AlignLeft, 
  FileUp, 
  PenTool, 
  Camera, 
  MapPin,
  TrendingUp
} from 'lucide-react';
import { FormularioCampo } from '@/types/formulario';

interface FormularioFieldPaletteProps {
  onAddField: (tipo: FormularioCampo['tipo_campo']) => void;
}

const fieldTypes = [
  { type: 'texto' as const, icon: Type, label: 'Texto Curto' },
  { type: 'numero' as const, icon: Hash, label: 'Número' },
  { type: 'data' as const, icon: Calendar, label: 'Data' },
  { type: 'hora' as const, icon: Clock, label: 'Hora' },
  { type: 'checkbox' as const, icon: CheckSquare, label: 'Checkbox' },
  { type: 'radio' as const, icon: Circle, label: 'Opção Única' },
  { type: 'select' as const, icon: List, label: 'Lista Suspensa' },
  { type: 'textarea' as const, icon: AlignLeft, label: 'Texto Longo' },
  { type: 'escala' as const, icon: TrendingUp, label: 'Escala de Avaliação' },
  { type: 'arquivo' as const, icon: FileUp, label: 'Upload Arquivo' },
  { type: 'assinatura' as const, icon: PenTool, label: 'Assinatura' },
  { type: 'foto' as const, icon: Camera, label: 'Foto' },
  { type: 'localizacao' as const, icon: MapPin, label: 'Localização GPS' },
];

export const FormularioFieldPalette = ({ onAddField }: FormularioFieldPaletteProps) => {
  return (
    <Card className="p-4">
      <h3 className="text-lg font-semibold mb-4">Campos Disponíveis</h3>
      <div className="space-y-2">
        {fieldTypes.map(({ type, icon: Icon, label }) => (
          <Button
            key={type}
            variant="outline"
            className="w-full justify-start"
            onClick={() => onAddField(type)}
          >
            <Icon className="h-4 w-4 mr-2" />
            {label}
          </Button>
        ))}
      </div>
    </Card>
  );
};
